import { axios } from "../../lib";

export const login = ({username, password}) => {
    return axios.post('/auth/authenticate', {username, password})
}